import React, { useEffect, useRef, useState } from "react";
import TableStructure from "../CommonComponents/TableStructure";
import { getAllQuestionsData } from "../services/Questions";
import { useParams } from "react-router-dom";
// import { useSelector } from "react-redux";

const QuestionsTable = () => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortOrder, setSortOrder] = useState("asc"); // Sorting state
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchText, setSearchText] = useState('');
  const currentPage = 1;
  const { alias: postAlias } = useParams();
  // const session = useSelector((state) => state.session);
  const limit = 50; // Number of records per page

  // Fetch films from the API
  const fetchQuestions = async (page, term) => {
    setLoading(true);
    try {
      const result = await getAllQuestionsData(limit, page, postAlias, term);
      if (result?.data) {
        setRecords(citationFactor(result?.data || []));
      }
      result?.totalQuestions && setTotalRecords(result.totalQuestions);
    } catch (error) {
      console.error("Error fetching films:", error);
    } finally {
      setLoading(false);
    }
  };


  const citationFactor = (data) => {
    return data?.map((item, index) => {
      return {
        title: item?.title,
        template: item?.template?.template_name,
        seq: item?.seq,
        id: item?._id
      }
    })
  }

  const columns = [
    {
      label: "Title",
      accessor: "title",
    },
    {
      label: "Sequence",
      accessor: "seq",
    },
    {
      label: "Template",
      accessor: "template",
    }
  ]

  // Handle search button click
  const handleSearch = (searchTerm) => {
    if (searchTerm.trim()) {
      isInitialLoad.current = false; // Skip the first render
      setSearchText(searchTerm);
      fetchQuestions(1, searchTerm);
    }
  };

  const sortRecords = () => {
    const newSortOrder = sortOrder === "asc" ? "desc" : "asc"; // Update sortOrder first
    setSortOrder(newSortOrder);

    const sorted = [...records].sort((a, b) =>
      newSortOrder === "asc"
        ? a.title.localeCompare(b.title)
        : b.title.localeCompare(a.title)
    );

    setRecords(sorted);
  };

  const isInitialLoad = useRef(true);

  useEffect(() => {
    // if (isInitialLoad.current) {
    //   isInitialLoad.current = false; // Skip the first render
    //   return;
    // }

    fetchQuestions(currentPage, searchText);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const handleClear = () => {
    setSearchText('');
    fetchQuestions(1, "");
  };



  return (
    <TableStructure
      isAuthenticated={true} // TODO: change this to session.isAuthenticated
      handleSearch={handleSearch}
      handleClear={handleClear}
      currentPage={currentPage}
      totalPages={1}
      sortRecords={sortRecords}
      sortOrder={sortOrder}
      loading={loading}
      records={records}
      type={`posts/${postAlias}/quiz`}
      title="Quiz"
      addOption="true"
      totalRecords={totalRecords}
      columns={columns}
      pagination={false}
      mt={5}
    />
  );
};

export default QuestionsTable;
